import { getFamilyIds } from '@editor2/services/storeService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { type CourseState } from '@editor2/types/courseState';
import { NgTraditional } from '@editor2/types/ngTraditional';
import { type PageGroup } from '@editor2/types/pageGroup';

import { getDeletedModifiedConflict } from '../helpers/createConflictHelper';
import { getUpdatedValuesAndConflicts } from '../helpers/detectConflictHelper';

export class PageGroupConflictDetector {
	detectConflicts = (state: CourseState, node) => {
		const { family_id, pages, ...pageGroup } = node as PageGroup;

		const pageGroupPages = { pages: getFamilyIds(pages) };

		// if current is deleted but incoming is modified
		if (state.changes.page_groups[family_id]?.includes(ChangesStatus.Deleted)) {
			const conflict = getDeletedModifiedConflict({
				attribute: 'page_groups',
				entityType: NgTraditional.PageGroup,
				id: family_id,
				state,
				incoming: { family_id, ...pageGroup, ...pageGroupPages }
			});

			state.conflicts = [...state.conflicts, conflict];
			return;
		}

		const initial = state.initialCourse.page_groups.entities[family_id];
		const current = state.page_groups.entities[family_id];
		const incoming = { family_id, ...pageGroup, ...pageGroupPages };
		const attributes = { ...pageGroup, ...pageGroupPages };

		const payload = { initial, current, incoming, attributes, state };

		const data = getUpdatedValuesAndConflicts(payload);
		return data;
	};

	applyDiffToInitial = ({ state, family_id, updatedInitial }) => {
		state.initialCourse.page_groups.entities[family_id] = { family_id, ...updatedInitial };
	};

	applyDiffToCurrent = ({ state, family_id, updatedCurrent }) => {
		state.page_groups.entities[family_id] = { family_id, ...updatedCurrent };
	};

	applyConflict = ({ state, conflicts }) => {
		state.conflicts = [...state.conflicts, ...conflicts];
	};
}
